import React from "react"
import Heading from "../_UI/Heading"
import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"
import Text from "../Text"
import Image from "next/image"

export default function StrokeCard({ type, title, content, img, alt }) {
  return (
    <CardBox type={type} className="CardBox">
      <div className="imgWrapper">
        <Image src={img} alt={alt} object="cover" fill sizes="100vw" />
      </div>
      <div className="textWrapper">
        <Heading mb="0" as="h3" className="text-gradient" content={title} />
        <Text mb="0" content={content}></Text>
      </div>
    </CardBox>
  )
}

const CardBox = styled.div`
  border: 0.5px solid ${themeGet("colors.primary")};
  padding: 30px;
  border-radius: 30px;
  display: flex;
  gap: 30px;
  justify-content: flex-start;
  align-content: flex-start;
  position: relative;
  width: 100%;
  /* background-color: #fff; */
  .imgWrapper {
    display: ${props => (props.type === "img" ? "block" : "none")};
    background-color: rgba(0, 0, 0, 0) !important;
    width: 100px;
    height: 100px;
    flex: 0 1 100px;
    position: relative;
  }
  .textWrapper {
    display: flex;
    gap: 10px;
    flex-direction: column;
    justify-content: flex-start;
    flex: 1 0 30px;
  }
  &:nth-child(1) {
    grid-column: 1/2;
    grid-row: 1/3;
    flex-direction: column;
    .imgWrapper {
      width: 200px;
      height: 200px;
      flex: 1 1 200px;
    }
    .textWrapper {
      flex: 0 0 100px;
    }
    @media (max-width: 1000px) {
      grid-column: 1/2;
      grid-row: 1/2;
      flex-direction: row;
      .imgWrapper {
        width: 100px;
        height: 100px;
        flex: 0 1 100px;
      }
      .textWrapper {
        flex: 1 1 100px;
      }
    }
  }
  @media (max-width: 1000px) {
    padding: 15px;
    /* flex-direction: column; */
    gap: 10px;
    .imgWrapper {
    }
    .textWrapper {
    }
  }
`
